import { Box, Stack } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { L2KH2, L2KText } from "../ui/Typography";

interface Props {
  thumbnailUrl?: string;
}

export function ComingSoonOverlay({ thumbnailUrl }: Props) {
  return (
    <Box
      style={{
        position: "relative",
        aspectRatio: "16/9",
        borderRadius: "12px",
        overflow: "hidden",
        background: "#0a0a0f",
      }}
    >
      {thumbnailUrl && (
        <Box
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${thumbnailUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(6px) brightness(0.35)",
          }}
        />
      )}

      <Stack
        gap="md"
        align="center"
        justify="center"
        style={{
          position: "absolute",
          inset: 0,
          padding: 24,
          textAlign: "center",
        }}
      >
        <Box
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: "rgba(255, 152, 0, 0.12)",
            border: "2px solid rgba(255, 152, 0, 0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconLock size={24} color="#FF9800" />
        </Box>
        <L2KH2 style={{ margin: 0 }}>2.0 Launching Soon</L2KH2>
        <L2KText variant="secondary" style={{ maxWidth: 320 }}>
          We're putting the finishing touches on Learntokiz 2.0. Videos will be
          unlocked at launch.
        </L2KText>
      </Stack>
    </Box>
  );
}

export default ComingSoonOverlay;
